var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cpt-toast-inner flex-items-center gap-[10px]"},[_c('div',{staticClass:"title text-tx-1 text-[14px] font-semibold leading-[normal]",domProps:{"innerHTML":_vm._s(_vm.title)}}),(_vm.showSlot)?_c('div',{staticClass:"slot-wrapper"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }